import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DownloadDprService } from '@report/services';
import { StaticMessage } from '@shared/enums';
import { ImageCompressionType, ReportGenerationType } from '@shared/enums/dpr';
import { ToUtcDateTimePipe } from '@shared/pipes';
import { FileService } from '@shared/services/files';
import { ReportHistory } from 'app/dpr/models';

@UntilDestroy()
@Component({
  selector: 'app-report-history-modal',
  templateUrl: './report-history-modal.component.html',
  styleUrls: ['./report-history-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportHistoryModalComponent implements OnInit {
  processedReports: any[] = [];

  ImageCompressionType = ImageCompressionType;
  ReportGenerationType = ReportGenerationType;
  StaticMessage = StaticMessage;

  constructor(
    private dialogRef: MatDialogRef<ReportHistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      addWatermark: boolean;
      dprDetailId: number;
      displayId: number;
      hasImagesToPrint: boolean;
      isDigitalSignatureEnabled: boolean;
      title: string;
      reportHistory: ReportHistory;
    },
    private fileService: FileService,
    private downloadDprService: DownloadDprService,
    private toUtcDateTimePipe: ToUtcDateTimePipe
  ) {}

  ngOnInit(): void {
    this.processedReports = this.processReports();
  }

  download(fileUrl: string): void {
    this.fileService.download(
      fileUrl,
      this.data?.reportHistory?.fileName,
      'application/pdf'
    );
    this.dialogRef.close();
  }

  generate(downloadImageAtOriginalSize: boolean): void {
    const options = downloadImageAtOriginalSize
      ? `imageCompressionType=${
          downloadImageAtOriginalSize === true
            ? ImageCompressionType.None
            : ImageCompressionType.ResizeToFit
        }`
      : null;

    this.downloadDprService.downloadOnline({
      dprDetailId: this.data.dprDetailId,
      options,
      addWatermark: this.data.addWatermark,
      displayId: this.data.displayId,
    });

    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  //#region Private methods

  private processReports(): any[] {
    return this.data.reportHistory?.history?.map((x) => ({
      ...x,
      generatedOnText: $localize`:@@dpr.reportHistoryModal.txtGenereatedOn:Generated on ${this.toUtcDateTimePipe.transform(
        x.generatedOn
      )}:date: UTC`,
      generatedByText: $localize`:@@dpr.reportHistoryModal.txtGenereatedBy:Generated by ${x.userName}:userName:`,
      revisionNumberText: $localize`:@@dpr.reportHistoryModal.txtRevision: Revision: ${x.revision}:revision:`,
    }));
  }

  //#endregion
}
